import React from "react";
import { connect } from "react-redux";

import { withTheme, withStyles, MuiThemeProvider } from "@material-ui/core/styles";
import { createTheme } from "../../utils/muiCompat";
import "../../styles/components/vendors/react-loading-bar/index.css";

import applicationTheme from "../../styles/theme/applicationTheme";
import { PALETA_CLARA, aplicarVariaveisCss, cor, paletaDoModo, variaveisCss } from "../../styles/theme/paletaCores";
import { ModoTema, ModoTemaContext, gravarModoTema, lerModoTema, proximoModo } from "../../styles/theme/modoTema";

export const estilosThemeWrapper = {
  "@global": {
    ":root": variaveisCss(PALETA_CLARA),
    "html:root, html body, html #root": { backgroundColor: cor("fundoPagina") }
  },
  root: {
    width: "100%",
    minHeight: "100%",
    marginTop: 0,
    zIndex: 1
  }
};

//export const AppContext = React.createContext();

export class ThemeWrapper extends React.Component<ThemeWrapperProps, IThemeWrapperState> {
  constructor(props: ThemeWrapperProps) {
    super(props);
    const modo = lerModoTema();
    this.state = {
      pageLoaded: true,
      ...this.estadoDoModo(modo)
    };
  }

  componentDidMount = () => {
    this.aplicarModoNaRaiz(this.state.modoTema.modo);
    this.playProgress();
  };

  aplicarModoNaRaiz = (modo: ModoTema) => {
    aplicarVariaveisCss(document.documentElement, paletaDoModo(modo));
    document.documentElement.style.setProperty("color-scheme", modo);
  };

  estadoDoModo = (modo: ModoTema) => ({
    theme: createTheme(applicationTheme("conciliaTheme", modo)),
    modoTema: { modo, alternarModo: this.alternarModo }
  });

  alternarModo = () => {
    const modo = proximoModo(this.state.modoTema.modo);
    gravarModoTema(modo);
    this.aplicarModoNaRaiz(modo);
    this.setState(this.estadoDoModo(modo));
  };

  onProgressShow = () => {
    this.setState({ pageLoaded: true });
  };

  onProgressHide = () => {
    this.setState({ pageLoaded: false });
  };

  playProgress = () => {
    this.onProgressShow();
    setTimeout(() => {
      this.onProgressHide();
    }, 500);
  };

  render() {
    const { classes, children } = this.props;
    const { theme, modoTema } = this.state;
    return (
      <ModoTemaContext.Provider value={modoTema}>
        <MuiThemeProvider theme={theme}>
          <div className={classes.root}>{children}</div>
        </MuiThemeProvider>
      </ModoTemaContext.Provider>
    );
  }
}

interface ThemeWrapperProps {
  classes: any;
  children: any;
}

interface IThemeWrapperState {
  pageLoaded: boolean;
  theme: any;
  modoTema: React.ContextType<typeof ModoTemaContext>;
}

const mapStateToProps = (state: any) => ({
  force: state
  //color: state.getIn([reducer, 'theme']),
  //mode: state.getIn([reducer, 'type']),
});

const ThemeWrapperMapped = connect(mapStateToProps, null)(ThemeWrapper);

export default withTheme(withStyles(estilosThemeWrapper)(ThemeWrapperMapped));
